/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ConfigurazioneFormTranslatedDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GetConfigurazioneFormEsercenteRequestParams {
    slug: string;
    idTp: string;
}


export interface EsercenteConfigurazioneFormBandoServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Restituisce la configurazione del form esercente del bando (form risolto, $dynamic espansi). Endpoint pubblico: leggibile anche senza autenticazione. Il path variable {idTp} accetta sia l\&#39;UUID sia il codice del bando (risolto entro il comune).
     * 
     * @endpoint get /api/v1/esercente/comuni/{slug}/tipi-pratica/{idTp}/configurazione-form-esercente
* @param requestParameters
     */
    getConfigurazioneFormEsercente(requestParameters: GetConfigurazioneFormEsercenteRequestParams, extraHttpRequestParams?: any): Observable<ConfigurazioneFormTranslatedDTO>;

}
